export const breakpoints = [
  {
    classes: 'w-bk-6 bg-gray-700 text-gray-100',
    max: 'max-w-bk-6',
    width: 1280
  },
  {
    classes: 'w-bk-5 bg-gray-600 text-gray-100',
    max: 'max-w-bk-5',
    width: 1136
  },
  {
    classes: 'w-bk-4 bg-gray-700 text-white',
    max: 'max-w-bk-4',
    width: 1024
  },
  {
    classes: 'w-bk-3 bg-gray-400 text-gray-900',
    max: 'max-w-bk-3',
    width: 768
  },
  {
    classes: 'w-bk-2 bg-gray-300 text-gray-900',
    max: 'max-w-bk-2',
    width: 640
  },
  {
    classes: 'w-bk-1 bg-gray-200 text-gray-900',
    max: 'max-w-bk-1',
    width: 480
  }
];
